import useSWR, { mutate as globalMutate } from "swr";
import { API } from "../utils/constants";
import { authFetcher } from "./fetcher";

/**
 * useProfile — Fetches the authenticated user's own profile (SPR-008 FE-3).
 *
 * API: GET /api/profile → ProfileDto (CON-002 §1A). Requires Bearer token
 * (authed fetcher).
 *
 * @returns {{ profile: object|undefined, error: any, isLoading: boolean, mutate: Function }}
 */
export function useProfile() {
  const { data, error, isLoading, mutate } = useSWR(
    API.PROFILE.GET,
    authFetcher,
    { revalidateOnFocus: false }
  );

  return { profile: data, error, isLoading, mutate };
}

/**
 * invalidateProfile — Force-revalidates the profile SWR cache.
 * @returns {Promise<any>}
 */
export const invalidateProfile = () => globalMutate(API.PROFILE.GET);
